import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import Paper from '@material-ui/core/Paper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import { TableBaseStyle } from '../../../baseStyle/tableBaseStyle';

import { GetMeasureModel, MeasureLogDataType } from './MeasureLog';
import DateTImeDiv from '../../atoms/Div/DateTImeDiv';
import MeasureLogStatusManualDev from '../../molecules/Div/MeasureLogStatusManualDev';
import { tableUseStyles, MeasureLogStyle } from './MeasureLogStyle';

type MeasureLogGridProps = {
  onChangeData: (plcNo: string, aiCardNo: string, aiChannelNo: string, selectDate: string) => void;
};

/**
 * 計測一覧（for PLC ver）
 * @param props
 * @returns
 */
const MeasureLogGrid: React.FC<MeasureLogGridProps> = (props) => {
  const { t } = useTranslation();
  const tableBaseStyle = tableUseStyles();
  const baseClasses = TableBaseStyle();
  const pageStyle = MeasureLogStyle();
  const [selectedID, setSelectedID] = useState(0);
  const [measureLoglList, setMeasureLoglList] = useState<MeasureLogDataType[]>([]);

  useEffect(() => {
    GetMeasureModel().then((ret) => {
      setMeasureLoglList([...ret]);
    });

    const interval = setInterval(() => {
      GetMeasureModel().then((ret) => {
        setMeasureLoglList([...ret]);
      });
    }, 10000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  /**
   * グリッド選択行クリック
   * @param targetData
   * @param index
   */
  const rowClickAction = (targetData: MeasureLogDataType, index: number) => {
    setSelectedID(index + 1);
    props.onChangeData(
      String(targetData.PLC_NO),
      String(targetData.AI_CARD),
      String(targetData.AI_CH),
      dayjs(targetData.LOG_START).format('YYYY/MM/DD HH:mm:ss')
    );
  };

  //行選択の背景色一時置き
  let lineSelection = '';

  return (
    <div>
      <div className={`${lineSelection = tableBaseStyle.bodyRow} ${lineSelection = baseClasses.bodyRow}`}></div>
      <TableContainer component={Paper} className={pageStyle.tableContainer}>
        <Table aria-label="measure log" size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.日時', '日時')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>PLC</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.AIカード', 'AIカード')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>CH</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.収集時間', '収集時間')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.機器番号', '機器番号')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.機器名称', '機器名称')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.項目名称', '項目名称')}</TableCell>
              {/* <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.周期', '周期')}</TableCell> */}
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.開始日時', '開始日時')}</TableCell>
              <TableCell className={tableBaseStyle.headerCell}>{t('MeasureLogGrid.状態', '状態')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {measureLoglList?.map((item, index) => (
              <TableRow
                hover
                key={index + 1}
                onClick={() => {
                  rowClickAction(item, index);
                }}
                selected={selectedID === index + 1}
                className={lineSelection}
              >
                <TableCell className={tableBaseStyle.bodyCellCenter}>
                  <DateTImeDiv value={item.MSR_DATE} format={'YY/MM/DD HH:mm:ss'} />
                </TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.PLC_NO}</TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.AI_CARD}</TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.AI_CH}</TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>
                  {item.COL_TIME}
                  {t('MeasureLogGrid.秒', '秒')}
                </TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.DEV_NO}</TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.DEV_NAME}</TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>{item.ITM_NAME}</TableCell>
                {/* <TableCell className={tableBaseStyle.bodyCellCenter}>{item.DSP_STR}</TableCell> */}
                <TableCell className={tableBaseStyle.bodyCellCenter}>
                  <DateTImeDiv value={new Date(item.LOG_START)} format={'YY/MM/DD HH:mm:ss'} />
                </TableCell>
                <TableCell className={tableBaseStyle.bodyCellCenter}>
                  <MeasureLogStatusManualDev state={item.STATUS} manual={item.MANUAL} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default MeasureLogGrid;
